/**
 * Centralized date formatting utilities
 * Used across the application for consistent date/time formatting
 */

/**
 * Format a Date object to DD.MM.YYYY HH:MM:SS format
 * @param {Date} date - The date object to format
 * @returns {string} Formatted date string (e.g., "15.03.2024 14:30:45")
 */
export const formatDateTime = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const pad = (n) => String(n).padStart(2, '0');
  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = date.getFullYear();
  const hh = pad(date.getHours());
  const mm = pad(date.getMinutes());
  const ss = pad(date.getSeconds());

  return `${d}.${m}.${y} ${hh}:${mm}:${ss}`;
};

/**
 * Format epoch timestamp (seconds) to locale string
 * @param {number} epoch - Unix timestamp in seconds
 * @returns {string} Formatted date string using browser locale
 */
export const formatEpoch = (epoch) => {
  if (!epoch || isNaN(epoch)) {
    return 'N/A';
  }
  return new Date(epoch * 1000).toLocaleString();
};

/**
 * Format epoch timestamp (milliseconds) to locale string
 * @param {number} epochMs - Unix timestamp in milliseconds
 * @returns {string} Formatted date string using browser locale
 */
export const formatEpochMs = (epochMs) => {
  if (!epochMs || isNaN(epochMs)) {
    return 'N/A';
  }
  return new Date(epochMs).toLocaleString();
};

/**
 * Format epoch timestamp (seconds) to DD.MM.YYYY HH:MM:SS format
 * @param {number} epoch - Unix timestamp in seconds
 * @returns {string} Formatted date string (e.g., "15.03.2024 14:30:45")
 */
export const formatEpochToDateTime = (epoch) => {
  if (!epoch || isNaN(epoch)) {
    return 'Invalid Date';
  }
  return formatDateTime(new Date(epoch * 1000));
};
